"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var RealHubWarningDialog = function RealHubWarningDialog(_ref) {
  var classes = _ref.classes,
      show = _ref.show,
      onClose = _ref.onClose;
  return /*#__PURE__*/_react["default"].createElement(_core.Dialog, {
    open: show,
    onClose: onClose
  }, /*#__PURE__*/_react["default"].createElement(_core.DialogTitle, null, "Realhub not linked"), /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.dialogContent
  }, /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body1",
    paragraph: true
  }, "Your Realhub username is not linked to your LJ Hooker account."), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body1",
    paragraph: true
  }, "Please login using your Realhub credentials via\xA0", /*#__PURE__*/_react["default"].createElement("a", {
    href: "https://www.realhubapp.com",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "https://www.realhubapp.com")), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    variant: "body1"
  }, "Alternative, please contact the team at Realhub on 02 9029 4025 or email\xA0", /*#__PURE__*/_react["default"].createElement("a", {
    href: "mailto:support@realhub.com.au",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "support@realhub.com.au"), "\xA0 for further assistance.")), /*#__PURE__*/_react["default"].createElement(_core.DialogActions, null, /*#__PURE__*/_react["default"].createElement(_core.Button, {
    onClick: function onClick() {
      return window.open("https://www.realhubapp.com", "_blank");
    },
    color: "secondary"
  }, "Ok")));
};

RealHubWarningDialog.propTypes = {
  classes: _propTypes["default"].object,
  show: _propTypes["default"].bool.isRequired,
  onClose: _propTypes["default"].func.isRequired
};

var _default = (0, _withStyles["default"])(_styles["default"])(RealHubWarningDialog);

exports["default"] = _default;